import * as React from "react"
import { slugify } from "../../../custom_utils/helpers"

export type ExpandProps = { innerKey: string; title: string; text?: string; open: boolean, child?: JSX.Element, onClick?: (e?) => void }

export const ExpandItem = (props: ExpandProps) => (
  <li key={slugify(props.innerKey)} className='expand__item'>
    <details className="expand__wrap">
      <summary className="expand__button" onClick={props.onClick}>
        <h3 className="expand__title title--ms">{props.title}</h3>
      </summary>

      {props.child != null
        ? <div className="expand__content richtext-block">{props.child}</div>
        : <div className="expand__content richtext-block" dangerouslySetInnerHTML={{ __html: props.text }} />
      }
    </details>
  </li>
)
